// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.browse[data-v-cd62093c]{\n\tpadding-bottom: 5px;\n}\n.view[data-v-cd62093c] {\n\tmargin-left: 30px;\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
